module.exports = __webpack_public_path__ + "assets/img/31_340_big.46cfff7c.jpg";